var map = {
	"./base.scss": "4cae",
	"./bg.jpg": "86d5",
	"./data/works": "a0a0",
	"./data/works.json": "a0a0",
	"./logos/climate_kic.png": "02bb",
	"./logos/climate_kic_white.png": "c053",
	"./remote_work.jpg": "90f5",
	"./svg/academy.svg": "54b9",
	"./svg/academy_color.svg": "a6ac",
	"./svg/campfire_color.svg": "9060",
	"./svg/company.svg": "5b1a",
	"./svg/events.svg": "6e35",
	"./svg/research.svg": "f15d",
	"./visual-frontpage.jpg": "1433"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";